import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IONIC_BASE_UI_COMPONENTS } from '@app/ionic-components-common/common-components';
import { TranslatePipe } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ModalBaseComponent } from '../modal-base/modal-base.component';
@Component({
    selector: 'medpace-user-idle-logout-modal',
    standalone: true,
    imports: [...IONIC_BASE_UI_COMPONENTS, TranslatePipe, RouterModule, CommonModule],
    templateUrl: './user-idle-logout-modal.component.html',
})
export class UserIdleLogoutModalComponent extends ModalBaseComponent {
    secondsTillTimeout$!: Observable<number>;
    getTimeLeft(secondsTillTimeout: number) {
        const minutes = Math.floor(secondsTillTimeout / 60);
        const minutesString = minutes.toString().padStart(2, '0');
        const seconds = secondsTillTimeout - minutes * 60;
        const secondsString = seconds.toString().padStart(2, '0');

        return minutesString + ':' + secondsString;
    }
    stay() {
        this.modalCtrl.dismiss({
            stay: true,
        });
    }
    logout() {
        this.modalCtrl.dismiss({
            logout: true,
        });
    }
}
